<template>
    <div class="no-authorization-msg-pp">
        Você não pode visualizar esta informação!
    </div>
</template>

<script>
export default {
    name: 'NoAuthorizationMsgPP'
}
</script>

<style scope src="./NoAuthorizationMsgPP-light-theme.css"></style>
<style scope src="./NoAuthorizationMsgPP-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/ui/no-authorization-msg-pp/NoAuthorizationMsgPP.vue